import { z } from 'zod'

export const completeTaskFormSchema = z.object({
  actualWorkDuration: z.number().min(0).multipleOf(15),
  endTime: z.string().regex(/^\d{2}:\d{2}$/, 'Invalid time format'),
})

export type CompleteTaskFormValues = z.infer<typeof completeTaskFormSchema>
